// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e0e72be1","156":"a31f658e","219":"790fcdc8","371":"a145099d","453":"5d9d47fd","597":"b8c102d7","909":"e0ec1544"}[chunkId] + ".chunk.js";
};